import { render } from "./simpleLayout.vue?vue&type=template&id=4417564f"
import script from "./simpleLayout.vue?vue&type=script&lang=js"
export * from "./simpleLayout.vue?vue&type=script&lang=js"

import "./simpleLayout.vue?vue&type=style&index=0&id=4417564f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__